//                                                                                                
//                                                            
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
//                                                                                                
//                                                            
function randomHex(byteCount) {
    //                                                                                       
    //                                                                              
    const arr = (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function')
        ? crypto.getRandomValues(new Uint8Array(byteCount))
        : Array.from({ length: byteCount }, () => (Math.random() * 256) | 0);
    return Array.from(arr, b => b.toString(16).padStart(2, '0')).join('');
}
const debugSessionUUID = uuidv4();
/* 
                                      
                 
                                                                               
 */
export const createHeader = (headers = {}, opts = {}) => {
    const version = '00';
    const traceId = randomHex(16);
    const id = randomHex(8);
    const flags = '01';
    const traceparent = `${version}-${traceId}-${id}-${flags}`;
    const tracestate = `bi=${id}`;
    const result = {
        ...headers,
        traceparent,
        tracestate,
        'LuxmsBI-Trace-Id': uuidv4(),
        'LuxmsBI-Context-Id': debugSessionUUID,
    };
    if (opts.biAppIdent)
        result['BI-App-Ident'] = opts.biAppIdent;
    return result;
};
export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
